'use strict';


import { matchModeManager } from 'models/MatchModeManager';
import { MatchModeManager } from 'models/MatchModeManager';
import { Match } from 'models/Match';
import { MatchGame } from 'models/MatchGame';
import { MatchSearchList } from 'components/MatchSearchList';
import { Location } from 'models/Location';
import applySearchFailReasons from 'functions/matchmaking/applySearchFailReasons';
import { League } from 'models/League';
import { User } from 'models/User';
import { Flair } from 'models/Flair';
import { Character } from '../models/Character';


import { ChatNotification } from 'models/ChatNotification';
import { ChatMessages } from 'models/ChatMessages';
import { ChatMessage } from 'models/ChatMessage';
import { ChatRoom } from 'models/ChatRoom';


import { ChatActions } from 'components/ChatActions';
import { Request } from 'components/Request';
import { Settings } from 'components/Settings';
import { SiteLinker } from 'components/SiteLinker';
import { UserInfo } from 'components/UserInfo';
import 'components/AdvancedMatchHistory';


import { FeaturedStreams } from 'models/Stream';
import { BrowserNotification } from 'components/BrowserNotification';
import { Timer } from 'components/Timer';
import { MatchHistoryTable } from 'components/MatchHistoryTable';
import { MatchHistory } from 'components/MatchHistory';

import { Html } from 'components/Html';
import LadderDistance from 'components/LadderDistance';


import { Dashboard } from 'components/Dashboard';
import { LadderPopup } from 'components/LadderPopup';
import { getOrdinal } from 'functions/getOrdinal';
import { DateFormat } from 'components/DateFormat';
import { Ladder, ladder } from 'components/Ladder';
import Infraction from 'models/Infraction';
import { ladderLocalStorage } from 'components/Ladder';
import { PostManager } from 'components/PostManager';
import SocketConnection from 'components/SocketConnection';
import { LinkedContinents } from 'components/LinkedContinents';
import { ChatMessageNotification } from 'models/ChatMessage';
import { Userlist } from 'models/Userlist';
import Distance from 'components/Distance';
import { Declickables, declickables } from 'components/Declickables';
import StreamsTabStreamsComponent from 'react/stream/StreamsTabStreamsComponent';
import { Stream } from 'models/Stream';
import getUrlParameter from 'functions/getUrlParameter';

import Globals from 'components/Globals';

import store from '../react/redux/store/store';
import * as featuredStreamsActions from '../react/redux/actions/featuredStreams';
import * as popupActions from '../react/redux/actions/popups';

import React from 'react';
import { renderIntoContainer } from 'react/root/containerRoot';
import PopupTypes from '../components/PopupTypes';

$.fn.timestampUpdate = function(timestamp) {
	var $this = this;
	return $this.each(function() {
		var element = $(this);
		if(typeof timestamp !== 'undefined') {
			element.data('timestamp', timestamp);
		}
		if(element.data('timestamp')) {
			element.text(DateFormat.smart(element.data('timestamp')));
		}
		else {
			element.text('');
		}
	});
};

Dashboard.Users = Users;

Dashboard.changeGameFilter = function(ladderId, activate) {
	let userFilter = null;
	if(myUser.preferred_games) {
		userFilter = myUser.preferred_games.retrieve(ladderId);
	}
	const data = {};
	data.ladder_id = ladderId;
	if(activate) {
		data.enabled = 1;
	}
	else {
		data.enabled = 0;
	}
	Request.apiv1('matchmaking/set_ladder_visibility_in_matchmaking', data).then((response) => {
		Dashboard.performOpenSearchUpdate(response);
		console.log(myUser.preferred_games);
		console.log(response);
	});
	if(userFilter) {
		userFilter.setEnabled(activate);
	}
};

if(top != self) {
	top.location.replace(document.location);
	alert('For security reasons, framing is not allowed; click OK to remove the frames.');
}

// Site-wide: a username anywhere opens its profile card (the netplay page's
// own handlers are in react/netplay/netplayPageHandlers).
Dashboard.usernameClick = function(button, e, clickedPosition) {
	const data = {};
	if(button.data('username')) {
		data.username = button.data('username');
	}
	else {
		data.username = button.text();
	}
	if(button.data('id')) {
		data.id = button.data('id');
	}

	let user = null;
	if(data.id) {
		user = Users.retrieveById(data.id);
	}
	else {
		user = Users.retrieveByUsername(data.username);
	}
	if(!user.username && data.username) {
		user.setUsername(data.username);
	}

	let position = {
		x: e.pageX,
		y: e.pageY,
	};
	const contextData = {
		chat_message_id: button.data('message_id'),
	};

	store.dispatch(popupActions.userClickPopupOpen(user, PopupTypes.PROFILE_CARD, position, contextData));
};

$('body').on('click', '.username, .online_user', function(e, clickedPosition) {
	var button = $(this);
	if(button.hasClass('unclickable')) {
		return;
	}
	if(button.data('userElement')) {
		button = button.data('userElement');
	}
	else if(button.hasClass('online_user')) {
		var innerButton = button.find('.username');
		if(innerButton.length) {
			button.data('userElement', innerButton);
			if(!innerButton.data('username')) {
				innerButton.data('username', innerButton.text());
			}
			button = innerButton;
			console.log('button', button);
		}
	}
	if(!button.data('username')) {
		button.data('username', button.text());
	}
	e.preventDefault();
	e.stopImmediatePropagation();
	if(clickedPosition) {
		e.pageX = clickedPosition.x;
		e.pageY = clickedPosition.y;
	}

	Dashboard.sleep(25).then(() => {
		return Dashboard.usernameClick(button, e, clickedPosition);
	});
});

Dashboard.updateSearchBasedOnUserSettings = applySearchFailReasons;

// Startup (Globals.getUserGoing) and the socket are site-wide:
// session/siteSession starts them from pages/sitePage on every page. The
// netplay page's own handlers bind when it enters the page area
// (react/netplay/netplayEntry).

(function($) {

	var proto = $.ui.autocomplete.prototype,
		initSource = proto._initSource;

	function filter(array, term) {
		var matcher = new RegExp($.ui.autocomplete.escapeRegex(term), 'i');
		return $.grep(array, function(value) {
			return matcher.test($('<div>').html(value.label || value.value || value).text());
		});
	}

	$.extend(proto, {
		_initSource: function() {
			if(this.options.html && $.isArray(this.options.source)) {
				this.source = function(request, response) {
					response(filter(this.options.source, request.term));
				};
			}
			else {
				initSource.call(this);
			}
		},

		_renderItem: function(ul, item) {
			return $('<li></li>')
				.data('item.autocomplete', item)
				.append($('<a></a>')[this.options.html ? 'html' : 'text'](item.label))
				.appendTo(ul);
		}
	});

})(jQuery);

// Dev-only Alt+number shortcuts for jumping a match between scenario presets.
if(IS_LOCALHOST) {
	$(() => {
		if(!window.myUser || !window.myUser.id) {
			return;
		}
		import(/* webpackChunkName: "MatchScenarioShortcuts" */ 'react/dev/matchScenarios/MatchScenarioShortcuts')
			.then(({ default: MatchScenarioShortcuts }) => {
				const holder = document.createElement('div');
				document.body.appendChild(holder);
				// Applies the current match the way the socket does, all_entries
				// included, so having no match clears one a stale push left behind.
				const resyncCurrentMatch = () => Request.apiv1Get('match/current_match').then((response) => {
					const currentMatches = { all_entries: true };
					if(response.match) {
						currentMatches[response.match.id] = response.match;
					}
					Dashboard.performOpenSearchUpdate({ current_matches: currentMatches });
				});
				renderIntoContainer(<MatchScenarioShortcuts onMatchChanged={resyncCurrentMatch} />, holder);
			});
	});
}

